/* GumTek theme — progressive enhancement only.
   Everything below degrades to a working page if JS fails. */
(function () {
  'use strict';

  /* ---------- Announcement bar dismiss (session only) ---------- */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    try {
      if (sessionStorage.getItem('gt-announce-closed') === '1') announce.hidden = true;
    } catch (e) {}
    var closeBtn = announce.querySelector('[data-announce-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        announce.hidden = true;
        try { sessionStorage.setItem('gt-announce-closed', '1'); } catch (e) {}
      });
    }
  }

  /* ---------- Mega menu ---------- */
  var navItems = document.querySelectorAll('[data-nav-item]');
  var isTouch = window.matchMedia('(hover: none)').matches || window.innerWidth < 760;

  function closeAllNav(except) {
    navItems.forEach(function (item) {
      if (item === except) return;
      item.setAttribute('data-open', 'false');
      var t = item.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      // Touch: first tap opens the panel, because there is no hover to reveal it.
      // Pointer: hover already revealed it, so let the click follow the link.
      if (!isTouch) return;
      e.preventDefault();
      var open = item.getAttribute('data-open') === 'true';
      closeAllNav(item);
      item.setAttribute('data-open', open ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    if (!isTouch) {
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        closeAllNav(item);
        item.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          item.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
        }, 120);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllNav(null);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) closeAllNav(null);
  });

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-mobile-open') === 'true';
      nav.setAttribute('data-mobile-open', open ? 'false' : 'true');
      navToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    val = btn.getAttribute('data-qty') === 'up' ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-media-id');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
      gallery.querySelectorAll('[data-gallery-image]').forEach(function (img) {
        img.hidden = img.getAttribute('data-media-id') !== id;
      });
    });
  }

  /* ---------- Variant selection ----------
     Reads the JSON blob Shopify renders, swaps price/availability/URL. */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-variant-price]');
    var wasEl = form.querySelector('[data-variant-was]');
    var skuEl = form.querySelector('[data-variant-sku]');
    var submit = form.querySelector('[data-add-button]');
    var stockEl = form.querySelector('[data-variant-stock]');
    if (!select) return;

    function money(cents) {
      var cur = form.getAttribute('data-currency') || 'GBP';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: cur
        }).format(cents / 100);
      } catch (e) {
        return '£' + (cents / 100).toFixed(2);
      }
    }

    select.addEventListener('change', function () {
      var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = money(v.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (stockEl) {
        stockEl.textContent = v.available ? 'In stock' : 'Out of stock';
        stockEl.className = v.available ? 'card__stock' : 'card__stock card__stock--out';
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? 'Add to basket' : 'Out of stock';
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-tab]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        buttons.forEach(function (b) {
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        group.parentNode.querySelectorAll('[data-tab-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-tab-panel') !== target;
        });
      });
    });
  });

  /* ---------- Facet + sort auto-submit ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
})();
